/** Great-circle (haversine) distance between two points, in miles. */
export function haversineMiles(
    a: { lat: number; lng: number },
    b: { lat: number; lng: number },
): number {
    const EARTH_RADIUS_MI = 3958.8
    const toRad = (deg: number) => (deg * Math.PI) / 180
    const dLat = toRad(b.lat - a.lat)
    const dLng = toRad(b.lng - a.lng)
    const h =
        Math.sin(dLat / 2) ** 2 +
        Math.cos(toRad(a.lat)) * Math.cos(toRad(b.lat)) * Math.sin(dLng / 2) ** 2
    return 2 * EARTH_RADIUS_MI * Math.asin(Math.sqrt(h))
}

/** Display form: "12 mi" under 100, "1,240 mi" above. Straight-line, not road. */
export function formatMiles(miles: number): string {
    const rounded = Math.round(miles)
    return `${rounded.toLocaleString('en-US')} mi`
}
